export class ParujRecznieModel {
    idLokalizacji: string;
    idProjektu: string;
    idSpisanegoSrodka: string;
    idSrodkaEwidencji: string;
    komentarzParowania: string;
}